import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { legalCss, SiteNav, SiteFooter, LegalPreloader } from "../components/LegalChrome";

const profileCss = `
  .pr-body { max-width: 560px; margin: 0 auto; padding: 20px 24px 120px; }
  .pr-card {
    background: var(--white); padding: 40px; display: flex; align-items: center; gap: 22px;
    box-shadow: 0 2px 24px rgba(7,79,79,0.06); margin-bottom: 32px;
  }
  .pr-avatar {
    width: 64px; height: 64px; border-radius: 50%; border: 1.5px solid var(--teal);
    display: flex; align-items: center; justify-content: center; font-family: var(--serif);
    font-size: 24px; color: var(--teal); background: rgba(7,79,79,0.05); flex-shrink: 0;
  }
  .pr-card h2 { font-family: var(--serif); font-size: 24px; font-weight: 400; color: var(--teal); margin-bottom: 4px; }
  .pr-card p { font-size: 13px; color: var(--text-l); }
  .pr-badge {
    display: inline-block; margin-top: 8px; font-size: 10px; font-weight: 600; letter-spacing: 1px;
    text-transform: uppercase; color: var(--gold); border: 1px solid rgba(198,167,105,0.4);
    padding: 3px 10px;
  }
  .pr-sec { background: var(--white); padding: 28px 32px; margin-bottom: 20px; }
  .pr-sec h3 {
    font-size: 10px; font-weight: 600; letter-spacing: 2px; text-transform: uppercase;
    color: var(--gold); margin-bottom: 16px;
  }
  .pr-row { display: flex; align-items: center; justify-content: space-between; padding: 10px 0; }
  .pr-row + .pr-row { border-top: 1px solid rgba(7,79,79,0.06); }
  .pr-row span:first-child { font-size: 13px; color: var(--text-l); }
  .pr-row span:last-child { font-size: 13px; color: var(--text); font-weight: 500; }
  .pr-actions { display: flex; flex-direction: column; gap: 10px; }
  .pr-btn {
    display: flex; align-items: center; gap: 10px; padding: 13px 16px; font-size: 13px;
    color: var(--text); background: none; border: 1px solid rgba(7,79,79,0.14); cursor: pointer;
    text-align: left; transition: all 0.3s;
  }
  .pr-btn:hover { border-color: var(--teal); color: var(--teal); }
  .pr-btn svg { width: 15px; height: 15px; opacity: 0.6; flex-shrink: 0; }
  .pr-btn.danger { color: #b33; border-color: rgba(187,51,51,0.25); }
  .pr-btn.danger:hover { border-color: #b33; background: rgba(187,51,51,0.04); }
  .pr-loading { text-align: center; padding: 160px 24px; color: var(--text-l); font-size: 14px; }
`;

const Profile = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
      return;
    }
    fetch("https://awaretherapycenter.ro/accounts/whoami/", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Unauthorized");
        return res.json();
      })
      .then((data) => {
        setUser(data);
        setLoading(false);
      })
      .catch(() => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        navigate("/login");
      });
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_first_name");
    localStorage.removeItem("user_last_name");
    window.location.href = "/";
  };

  const initials = user
    ? ((user.first_name ? user.first_name.charAt(0) : "") + (user.last_name ? user.last_name.charAt(0) : "")).toUpperCase() || "?"
    : "?";

  return (
    <div className="lg-root">
      <style>{legalCss}</style>
      <style>{profileCss}</style>
      <LegalPreloader />
      <div className="lg-grain" />

      <SiteNav />

      {loading ? (
        <div className="pr-loading">Se încarcă profilul...</div>
      ) : (
        <>
          <section className="lg-hero" style={{ paddingBottom: 40 }}>
            <div className="lg-label">Aware</div>
            <h1>Profilul meu</h1>
          </section>

          <div className="pr-body">
            <div className="pr-card">
              <div className="pr-avatar">{initials}</div>
              <div>
                <h2>{user.first_name} {user.last_name}</h2>
                <p>{user.email}</p>
                {user.is_staff && <span className="pr-badge">Admin</span>}
              </div>
            </div>

            <div className="pr-sec">
              <h3>Detalii cont</h3>
              <div className="pr-row"><span>Nume</span><span>{user.first_name} {user.last_name}</span></div>
              <div className="pr-row"><span>Email</span><span>{user.email}</span></div>
            </div>

            <div className="pr-sec">
              <h3>Acțiuni</h3>
              <div className="pr-actions">
                <button className="pr-btn" onClick={handleLogout}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                  Deconectare
                </button>
                <a
                  className="pr-btn danger"
                  href={`mailto:psihologie.aware@gmail.com?subject=${encodeURIComponent("Solicitare ștergere cont")}&body=${encodeURIComponent(`Bună ziua,\n\nVă rog să ștergeți contul meu (${user.email}) și datele asociate.\n\nMulțumesc.`)}`}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14z"/></svg>
                  Solicită ștergerea contului
                </a>
              </div>
            </div>
          </div>
        </>
      )}

      <SiteFooter />
    </div>
  );
};

export default Profile;
